import type { SVGProps } from 'react';
const DawnFlagTJ = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <path
      fill="#fff"
      d="M0 2a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
    />
    <path
      fill="#F5F5F5"
      fillRule="evenodd"
      d="M20 .5H2A1.5 1.5 0 0 0 .5 2v12A1.5 1.5 0 0 0 2 15.5h18a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 20 .5M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"
      clipRule="evenodd"
    />
    <mask
      id="dawn-flag-TJ_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-TJ_svg__a)">
      <path fill="#D9101C" d="M0 5.333h22V0H0z" />
      <path fill="#0F7811" d="M0 16h22v-5.333H0z" />
      <path
        fill="#FAD14E"
        d="M10.476 6.933a.53.53 0 0 1-.524.534.53.53 0 0 1-.524-.534c0-.294.235-.533.524-.533s.524.239.524.533M11.523 8c0 .096-.025.301-.069.533h.584a.533.533 0 0 1 0 1.067H9.962a.533.533 0 0 1 0-1.067h.583a3.5 3.5 0 0 1-.07-.533c0-.295.235-.533.525-.533.289 0 .524.238.524.533m1.048-1.067a.53.53 0 0 1-.524.534.53.53 0 0 1-.524-.534c0-.294.235-.533.524-.533s.524.239.524.533m1.572 1.6c.289 0 .523-.239.523-.533a.53.53 0 0 0-.524-.533.53.53 0 0 0-.523.533c0 .294.234.533.524.533M8.38 8a.53.53 0 0 1-.524.533A.53.53 0 0 1 7.333 8c0-.295.235-.533.524-.533s.524.238.524.533"
      />
    </g>
  </svg>
);
export default DawnFlagTJ;
